import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Logo from "../images/logo1.png";
import styles from "../css/landing.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBorderAll,
  faUserPlus,
  faUserGroup,
  faClipboardUser,
  faMoneyBill,
  faMoneyBill1,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";

// Navigation items per branch. These mirror the existing routes so no
// working logic changes — only where the sidebar is shown.
const NAV_ITEMS = {
  kharis: [
    { label: "Dashboard", icon: faBorderAll, path: "/kharispage" },
    { label: "Add Member", icon: faUserPlus, path: "/addmember" },
    { label: "View Members", icon: faUserGroup, path: "/allmembers" },
    { label: "Attendance", icon: faClipboardUser, path: "/attendance" },
    { label: "Tithe", icon: faMoneyBill, path: "/paytithe" },
    { label: "First Fruit", icon: faMoneyBill1, path: "/payfirstfruit" },
    { label: "Finance", icon: faReceipt, path: null },
  ],
  faith: [
    { label: "Dashboard", icon: faBorderAll, path: "/faithpage" },
    { label: "Add Member", icon: faUserPlus, path: "/addmemberfaith" },
    { label: "View Members", icon: faUserGroup, path: "/allmembersfaith" },
    { label: "Attendance", icon: faClipboardUser, path: "/attendancefaith" },
    { label: "Tithe", icon: faMoneyBill, path: "/paytithefaith" },
    { label: "First Fruit", icon: faMoneyBill1, path: "/payfirstfruitfaith" },
    { label: "Finance", icon: faReceipt, path: null },
  ],
  goaso: [
    { label: "Dashboard", icon: faBorderAll, path: "/goasopage" },
    { label: "Add Member", icon: faUserPlus, path: "/addmembergoaso" },
    { label: "View Members", icon: faUserGroup, path: "/allmembersgoaso" },
    { label: "Attendance", icon: faClipboardUser, path: "/attendancegoaso" },
    { label: "Tithe", icon: faMoneyBill, path: "/paytithegoaso" },
    { label: "First Fruit", icon: faMoneyBill1, path: "/payfirstfruitgoaso" },
    { label: "Finance", icon: faReceipt, path: null },
  ],
};

function Sidebar({ variant = "kharis" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const items = NAV_ITEMS[variant] || NAV_ITEMS.kharis;
  const BRANDS = { kharis: "Kharis", faith: "Faith", goaso: "Goaso" };
  const brand = BRANDS[variant] || "Kharis";

  // Listen for the Topbar hamburger (decoupled via a window event so the
  // header and sidebar stay independent, drop-in components).
  useEffect(() => {
    const toggle = () => setOpen((v) => !v);
    window.addEventListener("kharis-toggle-sidebar", toggle);
    return () => window.removeEventListener("kharis-toggle-sidebar", toggle);
  }, []);

  const handleNav = (path) => {
    if (path) navigate(path);
    setOpen(false);
  };

  return (
    <>
      {/* Dim overlay on mobile when the drawer is open */}
      {open && (
        <div
          className={styles.sidebarOverlay}
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside className={`${styles.sidebar} ${open ? styles.sidebarOpen : ""}`}>
        <div className={styles.sideTop}>
          <div className={styles.logoWrap}>
            <img src={Logo} alt={`${brand} Temple`} className={styles.logoImg} />
          </div>
          <div className={styles.brandText}>
            <div className={styles.brandName}>
              {brand} <span className={styles.brandAccent}>Admin</span>
            </div>
            <div className={styles.brandSmall}>Temple Dashboard</div>
          </div>
        </div>

        <nav className={styles.nav}>
          {items.map((item) => {
            const active = item.path && location.pathname === item.path;
            return (
              <button
                key={item.label}
                className={`${styles.navItem} ${active ? styles.navItemActive : ""}`}
                onClick={() => handleNav(item.path)}
              >
                <span className={styles.navIcon}>
                  <FontAwesomeIcon icon={item.icon} />
                </span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
